(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["os-journey"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('os-scroll-journey')) {
  customElements.define('os-scroll-journey', class extends HTMLElement {
    connectedCallback() {
      this.stages = [...this.querySelectorAll('.journey-stage')];
      this.track = this.querySelector('.journey-stages');
      if (!this.track || !this.stages.length) return;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); }); };
      this.visibilityObserver = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) { window.addEventListener('scroll', this.schedule, {passive:true}); this.schedule(); }
        else window.removeEventListener('scroll', this.schedule);
      }, {rootMargin:'150px'});
      this.visibilityObserver.observe(this.track);
      window.addEventListener('resize', this.schedule, {passive:true});
      this.motion.addEventListener('change', this.schedule);
      this.observer = new ResizeObserver(this.schedule);
      this.observer.observe(this.track);
      this.schedule();
    }
    update() {
      const trackTop = this.track.getBoundingClientRect().top;
      const centers = this.stages.map(stage => { const r = stage.querySelector('.journey-node').getBoundingClientRect(); return r.top + r.height / 2; });
      const first = centers[0];
      const length = Math.max(0, centers[centers.length - 1] - first);
      const anchor = window.innerHeight * .57;
      const progress = Math.max(0, Math.min(length, anchor - first));
      this.track.style.setProperty('--rail-top', `${first - trackTop}px`);
      this.track.style.setProperty('--rail-height', `${length}px`);
      this.track.style.setProperty('--journey-progress', `${progress}px`);
      this.track.style.setProperty('--journey-ratio', String(length ? progress / length : 0));
      const active = centers.reduce((current, center, index) => center <= anchor ? index : current, 0);
      this.stages.forEach((stage, index) => {
        stage.classList.toggle('is-reached', this.motion.matches || centers[index] <= anchor);
        stage.classList.toggle('is-active', !this.motion.matches && index === active);
      });
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      this.motion?.removeEventListener('change', this.schedule);
      this.observer?.disconnect();
      this.visibilityObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["osde-journey"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('os-scroll-journey')) {
  customElements.define('os-scroll-journey', class extends HTMLElement {
    connectedCallback() {
      this.stages = [...this.querySelectorAll('.journey-stage')];
      this.track = this.querySelector('.journey-stages');
      if (!this.track || !this.stages.length) return;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); }); };
      this.visibilityObserver = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) { window.addEventListener('scroll', this.schedule, {passive:true}); this.schedule(); }
        else window.removeEventListener('scroll', this.schedule);
      }, {rootMargin:'150px'});
      this.visibilityObserver.observe(this.track);
      window.addEventListener('resize', this.schedule, {passive:true});
      this.motion.addEventListener('change', this.schedule);
      this.observer = new ResizeObserver(this.schedule);
      this.observer.observe(this.track);
      this.schedule();
    }
    update() {
      const trackTop = this.track.getBoundingClientRect().top;
      const centers = this.stages.map(stage => { const r = stage.querySelector('.journey-node').getBoundingClientRect(); return r.top + r.height / 2; });
      const first = centers[0];
      const length = Math.max(0, centers[centers.length - 1] - first);
      const anchor = window.innerHeight * .57;
      const progress = Math.max(0, Math.min(length, anchor - first));
      this.track.style.setProperty('--rail-top', `${first - trackTop}px`);
      this.track.style.setProperty('--rail-height', `${length}px`);
      this.track.style.setProperty('--journey-progress', `${progress}px`);
      this.track.style.setProperty('--journey-ratio', String(length ? progress / length : 0));
      const active = centers.reduce((current, center, index) => center <= anchor ? index : current, 0);
      this.stages.forEach((stage, index) => {
        stage.classList.toggle('is-reached', this.motion.matches || centers[index] <= anchor);
        stage.classList.toggle('is-active', !this.motion.matches && index === active);
      });
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      this.motion?.removeEventListener('change', this.schedule);
      this.observer?.disconnect();
      this.visibilityObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
